// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"2474d3c5","433":"cc3398ab","453":"81e3e140","480":"a1deaa7e","583":"caa78b0d","612":"17710c22","796":"a62bfd84","818":"5fb6759f","830":"cfb48d0a"}[chunkId] + ".chunk.js";
};